var React = require('react');

function Close24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Close, Size=24x24"},React.createElement("path",{"id":"Vector","d":"M20.485 3.515L12 12m0 0l-8.485 8.485M12 12l8.485 8.485M12 12L3.515 3.515","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Close24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close24x24;

Close24x24.default = Close24x24;
